<template>
	<div class="loyalty-page">
		<div class="loyalty-landing has-text-centered"> <img id="friends-img" alt="Friends gathered around"
				src="@/assets/loyalty/friends.png" />
			<div v-if="points.hasAvailible">
				<h2 class="is-size-4">🎉🍕</h2>
				<h5 class="is-size-5 store-loyalty-text-color"> <span v-if="1 < points.itemsAvailable">
						{{points.itemsAvailable}} FREE PIZZAS ARE</span> <span v-else>A FREE PIZZA IS</span> <br />
					WAITING FOR YOU! </h5>
				<p>Reedemable at checkout</p>
			</div>
			<div v-else>
				<h5 class="is-size-5 store-loyalty-text-color">Congratulations!</h5>
				<p>You've earned</p>
			</div>
			<div class="pill-container">
				<p class="store-loyalty-text-color is-bolder loyalty-pill has-background-white reward-pill is-size-4"
					tabindex="0" :aria-label="`you have ${getLoyaltyPointsString} ${$appConstants.pointsName}`">
					{{getLoyaltyPointsString}}</p>
			</div>
			<p>{{ $appConstants.pointsName }} <br /> Earn {{points.pointsNeeded.toLocaleString()}} more points for your
				<span v-if="points.available">next</span> FREE pizza</p>
			<div class="loyalty-offer-coupons" v-if="hasCouponOffers()"><br />
				<h2 class="is-size-5 store-loyalty-text-color">You have the following coupons available:</h2>
				<div v-for="offerCoupon in getCouponOffers()" :key="offerCoupon.uniqueId"><a
						@click="getItemRouteIfAvailable(offerCoupon)">
						<h5 class="is-size-5 store-loyalty-text-color offer-background">{{ offerCoupon.name }}</h5>
					</a></div>
			</div>
		</div>
		<div class="redemption-section">
			<div class="redemption-body">
				<div class="redemption-body-section">
					<h5 class="is-size-5 store-loyalty-text-color ">How do I earn my free Pizza?</h5>
					<p>Simple, for each $1 spent, you earn {{franchisor.loyaltyPointsForPurchaseFactor * 100}}
						{{$appConstants.pointsName}}.</p>
					<p>After {{franchisor.loyaltyPointsPerReward}} {{$appConstants.pointsName}} earned, we reward you with a <span
							class="store-navigation-color">FREE PIZZA!</span></p>
					<p>Every purchase counts. Online, in store or via Phone. Delivery or Pickup</p>
				</div>
				<div class="redemption-body-section">
					<h5 class="is-size-5 store-loyalty-text-color ">How can I get my free Pizza?</h5>
					<p>Once you've earned {{franchisor.loyaltyPointsPerReward}} {{$appConstants.pointsName}}, you receive a
						FREE-PIZZA-COUPON in the online store. Or simply ask any Pizza Guy in any store for your reward.
						They will happily take care of you. </p>
				</div>
				<a target="_blank" href="https://www.touchpoint.io/terms" rel="noopener">
					<u>View Terms of Service</u>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import loyaltyMixin from '@Mixin/loyaltyMixin';
	export default {
		mixins: [
			loyaltyMixin,
		],
	}
</script>

<style lang="scss" scoped>
	@import "@style-vars";

	#friends-img {
		padding-top: 1em;
	}

	.loyalty-page {
		color: $storeTextColor;

		h5 {
			font-weight: 700;
		}

		.loyalty-offer-coupons {
			h5 {
				color: $defaultTextColor;
			}
		}

		.pill-container {
			margin: 0.5em 0em;
		}

		.loyalty-pill {
			max-width: 5em;
			margin: 0 auto;
			border-radius: 20px;
		}
	}

	.loyalty-landing {
		min-height: 20vh;
		background-color: $loyaltyContainer;
		width: 100%;
		padding: 2.5em 0em;
		margin-bottom: 2em;
	}

	.redemption-section {
		width: 100%;
		margin-bottom: 2em;
	}

	.redemption-body {
		width: 50%;
		margin: 0 auto;
	}

	.redemption-body-section {
		margin-bottom: 4.5em;
	}

	.redemption-body-section p {
		margin: 0.5em 0em 1em 0em;
	}

	@include mobile {
		.redemption-body {
			width: 75%;
		}

		h2 {
			margin: 0 1rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/loyalty/Loyalty.vue